import { SORTING_ORDER_TYPES } from 'taboola-ultimate-ui';
import { GRAPHS } from 'modules/campaigns/constants/graphTypes';
import { DAY_OF_WEEK } from '../../fields';
import metrics from '../../metrics';

const graph = {
    type: GRAPHS.BAR,
    endpoint: 'campaign-report-by-day-of-week-performance',
    metrics: [
        metrics.SPENT,
        metrics.COMPLETED_VIEWS,
        metrics.VIDEO_IMPRESSIONS,
        metrics.VIDEO_VISIBLE_IMPRESSIONS,
        metrics.VIDEO_CPM,
        metrics.VIDEO_VCPM,
        metrics.CPCV,
        metrics.VIEWABILITY_RATE,
        metrics.HUNDRED_PCT_VIEWABILITY_RATE,
        metrics.COMPLETION_RATE,
        metrics.CLICKS,
        metrics.VIDEO_CTR,
        metrics.VIDEO_VCTR,
        metrics.CPA,
        metrics.CVR,
        metrics.CONVERSIONS,
    ],
    defaultSort: [{ field: DAY_OF_WEEK.field, order: SORTING_ORDER_TYPES.ASCENDANT }],
    maxAllowedSelectedMetrics: 3,
    graphProps: {
        xAxisDataKey: DAY_OF_WEEK.field,
    },
};

export default graph;
